import './App.css';
import Home from './Home';
import RegisterStat from './RegisterStat';

function App() {
  return (
    <div>
      <RegisterStat endpoint='https://stats.soliman.nl/register' site="soliman.nl" app="home" module="home" />
      <Home />
    </div>
  );
}

export default App;
